import styled from 'styled-components'

export const FrontImageTogglerWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 0.5rem;
  align-items: center;
  line-height: normal;
  font-size: 1.4rem;
  padding: 0.5rem 1.2rem;

  @media screen and (min-width: 992px) {
    max-width: var(--container-max-width);
  }
`

export const FrontImageTogglerButton = styled.button<{ active?: boolean }>`
  background: transparent;
  border: none;
  border-bottom: 1.5px solid
    ${({ theme, active }) =>
      active ? theme.colors.text.primary : theme.colors.disabled};
  padding: 0;
`
